import { Moment } from 'moment/moment';
import { SelectOption } from '../../../../global';

export enum VOApiFilterType {
  STAGE = 'STAGE',
  TIERS = 'TIERS',
  STATUS = 'STATUS',
  DISPLAY = 'DISPLAY',
  LOCATION = 'LOCATION',
  SALES_REP = 'SALES_REP',
  SET_OF_DATA = 'SET_OF_DATA',
  CLOSED_DEALS = 'CLOSED_DEALS',
  APPLYING_FOR = 'APPLYING_FOR',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  SALES_MANAGER = 'SALES_MANAGER',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
  OPPORTUNITY_TYPE = 'OPPORTUNITY_TYPE',
  CREATE_DATE_RANGE = 'CREATE_DATE_RANGE',
  BPF_STAGE = 'BPF_STAGE',
  BPF_DEPARTMENT = 'BPF_DEPARTMENT',
}

export enum VOFilterType {
  BPF = 'BPF',
  STAGE = 'STAGE',
  TIERS = 'TIERS',
  STATUS = 'STATUS',
  DISPLAY = 'DISPLAY',
  LOCATION = 'LOCATION',
  SALES_REP = 'SALES_REP',
  SET_OF_DATA = 'SET_OF_DATA',
  CLOSED_DEALS = 'CLOSED_DEALS',
  APPLYING_FOR = 'APPLYING_FOR',
  PAYMENT_TYPE = 'PAYMENT_TYPE',
  SALES_MANAGER = 'SALES_MANAGER',
  FINANCE_MANAGER = 'FINANCE_MANAGER',
  OPPORTUNITY_TYPE = 'OPPORTUNITY_TYPE',
  CREATE_DATE_RANGE = 'CREATE_DATE_RANGE',
}

export enum VOFilterDisplayKeys {
  Active = 'Active',
  Testing = 'Testing',
  Duplicate = 'Duplicate',
  Other = 'Other',
}

export enum VOFilterDisplayPayloadValues {
  Active = 100,
  Testing = 200,
  Duplicate = 201,
  Other = 202,
}

export type VOFilters = {
  [VOFilterType.CLOSED_DEALS]: {
    isIncludeClosedDeals: boolean;
  };
  [VOFilterType.CREATE_DATE_RANGE]: {
    from: Moment;
    to: Moment;
  };
  [VOFilterType.DISPLAY]: Record<VOFilterDisplayKeys, boolean>;
  [VOFilterType.STATUS]: SelectOption[];
  [VOFilterType.LOCATION]: SelectOption[];
  [VOFilterType.SALES_REP]: SelectOption[];
  [VOFilterType.SET_OF_DATA]: SelectOption[];
  [VOFilterType.APPLYING_FOR]: SelectOption[];
  [VOFilterType.SALES_MANAGER]: SelectOption[];
  [VOFilterType.FINANCE_MANAGER]: SelectOption[];
  [VOFilterType.OPPORTUNITY_TYPE]: SelectOption[];
  [VOFilterType.STAGE]: Record<string, boolean | undefined>;
  [VOFilterType.TIERS]: Record<string, boolean | undefined>;
  [VOFilterType.PAYMENT_TYPE]: Record<string, boolean | undefined>;
  [VOFilterType.BPF]: {
    stages: SelectOption[];
    departments: SelectOption[];
  };
};

export interface VOFilterCardProps {
  meta?: Partial<Record<VOFilterType, SelectOption[]>>;
}

export type VOFiltersFormattedForPayload = {
  [VOApiFilterType.CREATE_DATE_RANGE]: {
    from: string;
    to: string | null;
  };
  [VOApiFilterType.DISPLAY]: VOFilterDisplayPayloadValues[];
  [VOApiFilterType.STATUS]: string[];
  [VOApiFilterType.LOCATION]: string[];
  [VOApiFilterType.OPPORTUNITY_TYPE]: string[];
  [VOApiFilterType.APPLYING_FOR]: string[];
  [VOApiFilterType.SALES_REP]: (string | null)[];
  [VOApiFilterType.SALES_MANAGER]: (string | null)[];
  [VOApiFilterType.FINANCE_MANAGER]: (string | null)[];
  [VOApiFilterType.STAGE]: string[];
  [VOApiFilterType.TIERS]: string[];
  [VOApiFilterType.PAYMENT_TYPE]: string[];
  [VOApiFilterType.BPF_STAGE]: string[];
  [VOApiFilterType.BPF_DEPARTMENT]: string[];
};

export type VOFiltersPayloadItem = {
  [K in keyof VOFiltersFormattedForPayload]: {
    key: K;
    value: VOFiltersFormattedForPayload[K];
  };
}[keyof VOFiltersFormattedForPayload];

export type VOFiltersPayload = VOFiltersPayloadItem[];
